import { render, staticRenderFns } from "./TMBTable.vue?vue&type=template&id=53150aa5&scoped=true"
import script from "./TMBTable.vue?vue&type=script&lang=js"
export * from "./TMBTable.vue?vue&type=script&lang=js"
import style0 from "./TMBTable.vue?vue&type=style&index=0&id=53150aa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53150aa5",
  null
  
)

export default component.exports